export const whatsapp = {
  bgClass: 'bg-[#25D366]',
  bgHoverClass: 'hover:bg-[#128C7E]',
  icon: 'mdi:whatsapp',
  textClass: 'text-[#25D366]',
  url: 'https://wa.me/33743394839',
}

export const googleMeet = {
  url: 'https://calendar.app.google/BDLDoE88zstYggug8',
}

export const phone = {
  label: '+33 7 43 39 48 39',
  number: '+33743394839',
  url: 'tel:+33743394839',
}

export const email = {
  email: 'info@quotatrip.com',
  url: 'mailto:info@quotatrip.com',
}
